<form [formGroup]="selectForm">
    <div class="row filter-section mt-1">
        <div class="col filter-div-1 d-flex justify-content-start align-items-center pb-2" #showref>
            <select *ngIf="volumeIssue" class="form-check-select black-label custom-select" aria-label="volume"
                formControlName="volumeSelect"  name="volume" (change)="getIssues();this.issue='Issue';">
                <option *ngFor="let volume of volumeData" value={{volume}} [disabled]="volume === 'Volume'">{{volume}}
                </option>
            </select>
            <select *ngIf="volumeIssue" class="form-check-select black-label custom-select"  name="issue" aria-label="issue" formControlName="issueSelect"
                (change)="getData()">
                <option *ngFor="let issue of issueData" value={{issue}} [disabled]="issue === 'Issue'">
                    {{changeIssue(issue)}}
                </option>
            </select>


            <div class="form-check black-label d-md-none d-none d-lg-block">
                <input style="cursor:pointer;" type="checkbox" class="form-check-input" id="check1" name="option1"
                    (keyup.enter)="checkBoxChange($event,'author')" (change)="checkBoxChange($event,'author')"
                    value="author" [checked]="uncheck['author']">
                <label class="form-check-label" for="check1">{{'article_listing.authors' |
                    translate}}</label>
            </div>
            <div class="form-check black-label d-md-none d-none d-lg-block">
                <input style="cursor:pointer;" type="checkbox" class="form-check-input" id="check2" name="option2"
                    (keyup.enter)="checkBoxChange($event,'doi')" (change)="checkBoxChange($event,'doi')" value="doi"
                    [checked]="uncheck['doi']">
                <label class="form-check-label" for="check2">{{'article_listing.doi' | translate}}</label>
            </div>
            <div class="form-check black-label d-md-none d-none d-lg-block">
                <input style="cursor:pointer;" type="checkbox" class="form-check-input" id="check3" name="option3"
                    (keyup.enter)="checkBoxChange($event,'keywords')" (change)="checkBoxChange($event,'keywords')"
                    value="keywords" [checked]="uncheck['keywords']">
                <label class="form-check-label" for="check3">
                    {{'article_listing.keywords' | translate}}
                </label>
            </div>
            <div *ngIf="subject_area_filter" class="form-check black-label d-md-none d-none d-lg-block">
                <input style="cursor:pointer;" type="checkbox" class="form-check-input" id="check4" name="option4"
                    (keyup.enter)="checkBoxChange($event,'subjectarea')" (change)="checkBoxChange($event,'subjectarea')"
                    value="subjectarea" [checked]="uncheck['subjectarea']">
                <label class="form-check-label" for="check4">
                    {{'article_listing.subjectareas' | translate}}
                </label>
            </div>
            <div class="form-check black-label d-md-none d-none d-lg-block">
                <input style="cursor:pointer;" type="checkbox" class="form-check-input" id="check6" name="option4"
                    (keyup.enter)="checkBoxChange($event,'article_title')"
                    (change)="checkBoxChange($event,'article_title')" value="article_title"
                    [checked]="uncheck['article_title']">
                <label class="form-check-label" for="check6">{{'article_listing.article_title' |
                    translate}}</label>
            </div>
            <div class="form-check-clear ml-2 d-md-none d-none d-lg-block">
                <span class="form-control clearall" role="button" tabindex="0" (click)="clearAllCheckbox()"
                    (keyup.enter)="clearAllCheckbox()" (keyup.space)="clearAllCheckbox()" *ngIf="clearButton">
                    {{'article_listing.clear_all' | translate}}
                </span>
                <!-- <fa-icon class="form-control clearall"  (click)="clearAllCheckbox()"
                (keyup.enter)="clearAllCheckbox()" (keyup.space)="clearAllCheckbox()" style="font-size:22px" [icon]="['fas', 'remove']"></fa-icon> -->
            </div>
            <div class="form-check-clear ml-1 mt-2">
 
                <fa-icon class="iconcls d-lg-none" [ngStyle]="{'color':highlightcolor}"
                    (click)="showFilterOptions()" aria-hidden="true" [icon]="['fas', 'filter']"></fa-icon>
            </div>
        </div>
    </div>
</form>